import React, { useState } from 'react';
import { useStyles } from './styles';
import { Box, Button, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Cookies
 from 'js-cookie';
import { useTheme } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import quickpay from '../../assets/QuickPay/quickpay.svg';
import { useHistory } from 'react-router-dom';

export const QuickAlert = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory();
  const [isLogin, setLoginStatus] = useState(Cookies.get('privateToken') ? true : false);
 
  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }}  open={props?.quickPay}>
      <Box className={classes.root}>

      <Grid container>
        <Grid item md={4} className={classes.img}>
         {!fullScreen && <img src={quickpay} />  } 
        </Grid>
        <Grid item md={8}>
          <IconButton onClick={props?.closeQuickPayPopup} className={classes.closeIcon}>
          <CancelIcon />
          </IconButton> 

          <Box className={classes.cardBody}>
            <Box>
              <p className={classes.statusTitle}>Make a Payment</p>
              <p className={classes.statusSubTitle}>To proceed with your payment, please <b>Sign In</b> to your MyLoanWeb account. </p>
            </Box>
            <Box className={classes.buttonContainer}>
              <Button type='submit' className={classes.signInBtn} size="medium"  variant="contained" color="primary" 
              onClick={() => history.push(isLogin ? '/PaymentOption' : '/SignIn')}>
                 { isLogin ? 'Make a Payment' : 'Sign In & PAY' }
              </Button>
            </Box>
            {/* <p className={classes.statusSubTitle}><b>Don’t have an account?</b> You can still make a payment without creating one—just click on <b>'Quick Pay'</b> to continue as a guest. </p> */}
            <p className={classes.statusSubTitle}><b>Don’t want to sign in?</b> You can still make a payment without signing in —just click on <b>Quick Pay</b> to continue as a guest.</p>
            <Box className={classes.buttonContainer}>
              <Button type='submit' className={classes.signInBtn} size="medium" onClick={() => history.push('/QuickPay')} variant="outlined" >
              QUICK PAY
              </Button>
            </Box>
          </Box>
         
        </Grid>
       </Grid> 
     
      </Box>
    </Dialog>
  )
}
